import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {IconsModule} from '../../services/icons.module';

import {NotificationsDrawerComponent} from './notifications-drawer.component';
import {NotificationManagerComponent} from './notification-manager/notification-manager.component';
import {SlackNotificationComponent} from './slack-notification/slack-notification.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    IconsModule,
    NotificationsDrawerComponent,
    NotificationManagerComponent,
    SlackNotificationComponent,
  ],
  exports: [NotificationsDrawerComponent],
})
export class NotificationsDrawerModule {}
